import { render, staticRenderFns } from "./memberCommentBoxDetail.vue?vue&type=template&id=0b956f18&scoped=true"
import script from "./memberCommentBoxDetail.vue?vue&type=script&lang=js"
export * from "./memberCommentBoxDetail.vue?vue&type=script&lang=js"
import style0 from "./memberCommentBoxDetail.vue?vue&type=style&index=0&id=0b956f18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b956f18",
  null
  
)

export default component.exports